export default function PixelCursor({ color = "var(--ink)", outline = "var(--paper)", size = 28 }) {
  return (
    <svg
      width={size}
      height={size * 1.14}
      viewBox="0 0 24 28"
      style={{ overflow: "visible" }}
    >
      <polygon
        points="3,2 3,22 9,17 13,24 16,23 12,16 19,16"
        fill={color}
        stroke={outline}
        strokeWidth="1.5"
      />
    </svg>
  );
}
